var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_46_2",
    "data-name": "Component 46 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 414.031,
    height: 157.047,
    viewBox: "0 0 414.031 157.047",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M466.086,318.094a178.855,178.855,0,0,1-275.054,0,39.294,39.294,0,0,0-60.414,50.263,257.738,257.738,0,0,0,395.88,0,39.294,39.294,0,1,0-60.413-50.263Z",
    transform: "translate(-121.578 -303.977)",
    fill: "#83b797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeComponent);
export default __webpack_public_path__ + "static/media/shape-component.4748061a43d04611af8a3b2782c2a2c2.svg";
export { ForwardRef as ReactComponent };